import remove from 'lodash/remove'
import { CreativeFolderModel } from './CreativeFolder'
import CreativeFolderApi from '@/api/CreativeFolder'
import { CreativeRepository } from '../Creative/CreativeRepository'

export class CreativeFolderRepository {
  static async create(data) {
    try {
      const result = await CreativeFolderApi.create(data)
      return CreativeFolderModel.assign(result.item)
    } catch (e) {
      console.error(e)
      throw new Error('クリエイティブフォルダの登録ができませんでした')
    }
  }

  static async update(data) {
    try {
      const result = await CreativeFolderApi.update(data.id, data)
      return CreativeFolderModel.assign(result.item)
    } catch (e) {
      console.error(e)
      throw new Error('クリエイティブフォルダ名の更新ができませんでした')
    }
  }

  /**
   * クリエイティブフォルダの削除を行う。
   * 先に所属するクリエイティブを全て削除し、完了後にクリエイティブフォルダを削除する。
   * @param {CreativeFolderModel} item
   */
  static async delete(item) {
    try {
      const { id, ownerProfileId } = item
      const result = await CreativeRepository.search({
        ownerProfileId,
        creativeFolderIds: [id],
      })
      await CreativeRepository.bulkDelete(result.items.map(c => c.id))
      await CreativeFolderApi.delete(id)
      return true
    } catch (e) {
      console.error(e)
      throw new Error('クリエイティブフォルダの削除ができませんでした')
    }
  }

  static async getRootByOwnerProfileId(ownerProfileId) {
    try {
      const result = await CreativeFolderApi.getListByOwnerProfileId(
        ownerProfileId,
      )
      const folders = result.items.map(i =>
        CreativeFolderModel.assign({ ...i, ownerProfileId }),
      )
      const [rootFolder] = remove(folders, f => f.isRoot)
      rootFolder.children = folders
      return rootFolder
    } catch (e) {
      console.error(e)
      throw new Error('クリエイティブフォルダが取得できません')
    }
  }
}
